import './DailyAffirmation.scss'

import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import parse from 'html-react-parser'

import { getDailyAffirmation } from '../../../common/api/Practices'
import { stripSlashes } from 'components/common/helpers/Strings'

export default function DailyAffirmation({ cache }) {
  const [todaysAffirmation, setTodaysAffirmation] = useState()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    ;(async function getDailyAffirmationAsync() {
      // Check cache first
      let affirmation = await cache.tryGetAsyncResult(
        'dailyAffirmation',
        getDailyAffirmation,
        this
      )

      // Replace slashes. Don't add line breaks because it looks weird on mobile
      // for the daily affirmation to wrap early
      affirmation = stripSlashes(affirmation)

      setTodaysAffirmation(affirmation)
      setIsLoading(false)
    })()
  }, [cache])

  return (
    <div className='daily-affirmation'>
      {isLoading || !todaysAffirmation ? (
        <Spinner
          animation='border'
          role='status'
          variant='primary'
          size='lg'
          className='my-3 mx-auto'
        >
          <span className='visually-hidden'>Loading...</span>
        </Spinner>
      ) : (
        <>
          <span className='daily-affirmation-text'>
            <small className='small'>Today...</small>
            <br />
            {parse(todaysAffirmation)}
          </span>
        </>
      )}
    </div>
  )
}
